import script from "./coupons.vue?vue&type=script&setup=true&lang=js"
export * from "./coupons.vue?vue&type=script&setup=true&lang=js"

import "./coupons.vue?vue&type=style&index=0&id=43c9b862&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43c9b862"]])

export default __exports__